import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';

import AuthCardLayout from '../../components/AuthCardLayout/AuthCardLayout';
import ContinueTo from '../Session/ContinueTo/ContinueTo';
import GrantPermission from '../NoSession/GrantPermission/GrantPermission';
import { AUTH_STEPS, AUTH_SESSION_STEPS, setStep } from '../../reducers/auth/authActions';
import { selectStep, selectAuthorizeResponse } from '../../reducers/auth/authSelectors';
import { retrieveAppUrl, clearAuthSession } from '../../reducers/auth/authAuthorizeHelpers';

const steps = [
  { id: AUTH_SESSION_STEPS.CONTINUE_AS, component: ContinueTo, route: '/continue-as' },
  { id: AUTH_STEPS.GRANT_PERMISSION, component: GrantPermission, route: '/verify-consent' },
];

function VerifyConsent() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const activeStep = useSelector(selectStep);
  const authorizeResponse = useSelector(selectAuthorizeResponse);
  const hasExistingSession = useSelector(state => state?.auth?.hasExistingSession);
  const hasCode = Boolean(authorizeResponse?.code);

  useEffect(() => {
    if (!hasCode) {
      const appUrl = retrieveAppUrl();
      if (appUrl) {
        clearAuthSession();
        window.location.href = appUrl;
      } else {
        navigate('/sign-in', { replace: true });
      }
      return;
    }

    const isConsentStep = [
      AUTH_SESSION_STEPS.CONTINUE_AS,
      AUTH_STEPS.GRANT_PERMISSION,
    ].includes(activeStep);

    if (!isConsentStep) {
      // If hasExistingSession → show "Continue As"
      // If !hasExistingSession → skip to "Grant Permission"
      if (hasExistingSession) {
        dispatch(setStep(AUTH_SESSION_STEPS.CONTINUE_AS));
      } else {
        dispatch(setStep(AUTH_STEPS.GRANT_PERMISSION));
      }
    }
 }, [activeStep, dispatch, hasCode, hasExistingSession, navigate]);

  // Sync URL with step
  useEffect(() => {
    const currentStep = steps.find(s => s.id === activeStep);
    if (currentStep?.route && location.pathname !== currentStep.route) {
      navigate(currentStep.route, { replace: true });
    }
  }, [activeStep, location.pathname, navigate]);

  if (!hasCode) return null;

  const currentStep = steps.find(s => s.id === activeStep);
  const StepComponent = currentStep?.component;

  return (
    <AuthCardLayout>
      {StepComponent ? <StepComponent /> : null}
    </AuthCardLayout>
  );
}

export default VerifyConsent;

